import Api from '../api';

let uri = '/api/ed/delegacion';

export const getDelegacionesUsuario = (data) => {
    return Api.getInstance().executeQuery('/api/ed/delegaciones', data)
        .then((resp) => resp?.data)
        .catch((error) =>
            console.log(error)
        );
}

export const createDelegacion = (data) => {
    return Api.getInstance().executeQuery(uri, data)
        .then(res => res)
        .catch(err => console.log(err));
}

export const editDelegacion = (data) => {
    return Api.getInstance.executeUpdateQuery(uri, data)
        .then(res => res)
        .catch(err => console.log(err));
}

export const deleteDelegacion = (data) => {
    return Api.getInstance().executeDeleteQuery(uri, { data: data })
        .then(res => res)
        .catch(err => console.log(err));
}



